import { maskVendor } from "@/shared/lib/vendorMask";
import type { ReporterTaskDto } from "../api/reporterService";

/**
 * N3(1013)「重写报错」:重写是异步任务,派发口的 402 早已走公共错误层(积分不足 + 充值提示),
 * 但**任务在 ai 侧失败**(ai 计费票 REJECTED = 余额耗尽、模型超时等)时工作台什么都不说 ——
 * 转圈消失、正文没变,草稿已翻 FAILED。这里把最近一次生成型任务的失败翻成人话给工作台横幅用。
 */
const GEN_TYPES = new Set(["GENERATE", "REWRITE_FULL", "REWRITE_SECTION"]);

/** 最近一次生成 / 重写任务若失败 → 该任务;否则 null(只看最近一次,之后成功过就不再提示)。 */
export function lastFailedGenTask(
  tasks: ReporterTaskDto[] | null | undefined
): ReporterTaskDto | null {
  const gen = (tasks ?? []).filter((t) => GEN_TYPES.has(t.type));
  if (!gen.length) return null;
  const latest = gen.reduce((a, b) => (b.id > a.id ? b : a));
  return latest.status === "FAILED" ? latest : null;
}

/** 失败原因人话:积分不足单独说清「没扣费 + 去充值」;其余脱敏后原样给,空则兜底。 */
export function rewriteFailureText(raw: string | null | undefined): string {
  const msg = (raw ?? "").trim();
  if (/积分|余额|credit|quota|402/i.test(msg)) {
    return "积分不足,这次重写没有完成也没有扣费;充值后再点重写即可。";
  }
  const masked = maskVendor(msg);
  return masked ? `${masked}(可直接再试一次)` : "这次没有完成,请稍后再试一次。";
}
